<div class="attachment-container">

  <div class="attachment-header">

    <div class="attachment-info">
      <span class="title">Attachments</span>

      <span class="meta">
        (Total size: {{ totalSizeMB }}MB / {{ maxSizeMB }}MB)
      </span>
      <span class="meta" *ngIf="mode === 'edit'">
        {{allowedTypes}}
      </span>
    </div>

    <ng-container *ngIf="mode === 'edit'">

      <button data-testid="auto-app-attachment-list-button-1"
        type="button"
        class="choose-btn"
        (click)="fileInput.click()">

        <i class="fa fa-paperclip"></i>
        Choose files
      </button>

      <input data-testid="auto-app-attachment-list-input-1"
        #fileInput
        hidden
        multiple
        type="file"
        [accept]="allowedTypes"
        (change)="onFileChange($event)">
    </ng-container>

  </div>

  <div
    class="attachment-list"
    *ngIf="files && files.length">

    <div
      class="file-chip"
      *ngFor="let file of files; trackBy: trackByFile">

      <div class="file-icon">
        📄
      </div>

      <div class="file-details">

        <div
          class="file-name"
          [title]="file.filename">

          {{ file.filename }}
        </div>

        <div class="file-size">
          ({{ file.size / 1024 | number:'1.0-0' }}KB)
        </div>

      </div>

      <a data-testid="auto-app-attachment-list-a-1"
        *ngIf="mode === 'view' && file.url"
        class="view-link"
        [href]="file.url"
        target="_blank">

        View
      </a>

      <button data-testid="auto-app-attachment-list-button-2"
        *ngIf="mode === 'edit'"
        type="button"
        class="remove-btn"
        (click)="remove(file)">
        ×
      </button>

    </div>

  </div>

</div>